<template>
  <div
    class="assessor-virtual"
    :class="{ visivel: $route.path == '/', hide: hidden }">
    <a class="close-button" style="color: black" @click="hide" v-if="!hidden">
      <i class="mdi mdi-close"></i>
    </a>
    <div class="text-center logo">
      <img :src="logo" class="logo" v-if="hidden" @click="hidden = false" />
      <img :src="logo" class="logo" v-if="!hidden" />
    </div>
    <div class="show-hover">
      <hr />
      <!--<div class="row">
                <div class="sm-6">
                    <p class="text-center">
                        <i class="mdi mdi-whatsapp"></i>
                        Whatsapp<br />
                        <a :href="whatsapp_link"  target="_blank">{{ whatsapp }}</a>
                    </p>
                </div>
                <div class="sm-6">
                    <p class="text-center">
                        <i class="mdi mdi-email-outline"></i>
                        E-mail<br />
                        <a :href="`mailto:${email}`" target="_blank">{{ email }}</a>
                    </p>
                </div>
            </div>-->
      <div class="row">
        <div class="sm-12">
          <p class="text-center">
            <i class="mdi mdi-clock-outline"></i>
            Horário de atendimento <br />
            De segunda a sexta, das 8h às 18h
          </p>
        </div>
      </div>
      <div class="row">
        <div class="sm-12">
          <a
            :href="whatsapp_link"
            target="_blank"
            class="default-button whatsapp">
            <i class="mdi mdi-whatsapp"></i>
            <!--Fale por Whatsapp-->
            {{ whatsapp }}
          </a>
          <a
            :href="`mailto:${email}`"
            target="_blank"
            class="default-button email">
            <i class="mdi mdi-email-outline"></i>
            <!--Envie um email-->
            {{ email }}
          </a>
          <!--
            <a @click="openFlowXO" class="default-button">
              <i class="mdi mdi-chat"></i>
              
              Tire suas dúvidas com a Agente Virtual!
            </a>
          -->
        </div>
        <!--
                    <div class="sm-6">
                        <a :href="`mailto:${email}`"  target="_blank" class="default-button email">
                            <i class="mdi mdi-email-outline"></i>
                            Envie um email
                        </a>
                    </div>
                -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hidden: this.$route.path != "/",
    };
  },
  filters: {
    phoneClear(str) {
      return str.replace(/\D+/gim, "");
    },
  },
  computed: {
    empresa() {
      return this.$store.state.empresa;
    },

    logo() {
      return this.empresa.assessor_virtual.logo;
    },
    whatsapp() {
      return this.empresa.assessor_virtual.whatsapp;
    },
    whatsapp_link() {
      let whatsapp = this.whatsapp.replace(/\D+/gim, "");
      return `https://wa.me/${whatsapp}`;
    },
    email() {
      return this.empresa.assessor_virtual.email;
    },
  },
  methods: {
    openFlowXO() {
      FxoMessenger.toggle();
    },
    hide() {
      this.hidden = true;
    },
  },
};
</script>
<style lang="less">
.assessor-virtual {
  position: fixed;
  bottom: 2em;
  left: 2em;
  z-index: 3;

  @media print {
    display: none;
  }

  @media (max-width: 40em) {
    bottom: 10px;
    left: 10px;
  }

  a {
    color: currentColor;
  }
  .default-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-weight: 400;
    text-transform: none;
    border-radius: 0.5em;
    font-size: 15px;
    padding: 5px 10px;
    color: white;
    i {
      font-size: 25px;
      margin-bottom: 0;
      display: inline-block;
      margin-right: 8px;
    }
    &.whatsapp {
      background-color: #25d366;
    }
    &.email {
      background-color: #64b5f6;
    }
  }
  .logo {
    max-height: 150px;
  }
  hr {
    margin: 1.5em 0;
    @media (max-width: 40em) {
      margin: 0.5em 0;
    }
  }

  .show-hover {
    display: none;
  }
  &:hover,
  &.visivel {
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.25);
    padding: 1em;
    min-width: 200px;
    box-shadow: 0 0 10px -5px;
    max-width: 100%;

    @media (max-width: 70em) {
      padding: 1em 0;
    }

    /*
        @media (max-width: 40em) {
            min-width: 0px;            
        }
        */

    .show-hover {
      display: block;
    }
    .logo {
      padding: 0.5em 3em;
    }
  }
  .close-button {
    padding: 1em;
    position: absolute;
    right: 0;
    top: 0;
    border: 0;
    background: none;
  }
  &.hide {
    min-width: 0;
    background-color: transparent;
    border: none;
    padding: 0;
    box-shadow: none;
    max-width: 60px;

    .show-hover {
      display: none;
    }
    .logo {
      padding: 0;
      background-color: none;
    }
    .close-button {
      display: none;
    }
  }
}
#app > main {
  //padding-bottom: 200px;
}
</style>
<style lang="less" scoped>
p.text-center {
  display: block;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: center;
  i.mdi-clock-outline {
    margin: 0;
    display: inline-block;
    font-size: 16px;
    margin-right: 5px;
  }
}
</style>
